import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_website_entity_link_RowClass} from '../../../dbschema';

export class WebsiteEntityLinkContainerModel extends BaseContainerModel {
  bl_cms_website_entity_link: bl_cms_website_entity_link_RowClass = new bl_cms_website_entity_link_RowClass();
}
